//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { roterPre } from '@/settings';
import { pinyin } from 'pinyin-pro';
import checkboxDialog from '@/components/develop/checkboxDialog';
import selectMember from '@/components/form-common/select-member';
import ueditorFrom from '@/components/form-common/oa-wangeditor';
export default {
  name: '',
  components: {
    checkboxDialog: checkboxDialog,
    selectMember: selectMember,
    ueditorFrom: ueditorFrom
  },
  props: {
    // 弹窗样式
    fromData: {
      type: Object,
      default: function _default() {}
    },
    // 表单内容
    formConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 表单绑定值
    formDataInit: {
      type: Object,
      default: function _default() {}
    },
    // 表单规则
    formRules: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      form: this.formDataInit,
      strData: '',
      onlyOne: false,
      fieldList: [],
      itemIndex: 0,
      itemData: {},
      userList: [],
      // 人员数据
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      }
    };
  },
  watch: {
    formDataInit: function formDataInit(val) {
      if (val.association_field_names_list && val.association_field_names_list.length > 0) {
        this.fieldList = val.association_field_names_list;
      }
      this.form = val;
    }
  },
  methods: {
    getDataFn: function getDataFn(data) {
      var _this = this;
      this.formDataInit.association_crud_id = data.id;
      this.form.association_field_names = [];
      this.fieldList = data.selectList;
      data.selectList.map(function (item) {
        _this.form.association_field_names.push(item.field_name_en);
      });
    },
    submit: function submit() {
      var _this2 = this;
      if (this.fromData.type == 'slot') {
        this.$emit('submit');
      } else {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            _this2.$emit('submit', _this2.form, _this2.fromData.type);
          }
        });
      }
    },
    // 刷新转拼音小写
    refreshFn: function refreshFn(refresh, key) {
      if (this.form[refresh] == '') {
        return false;
      }
      var regex = /^[\u4e00-\u9fa5a-zA-Z][\u4e00-\u9fa5a-zA-Z_]{0,15}$/;
      if (!regex.test(this.form[refresh])) {
        return false;
      }
      this.strData = pinyin(this.form[refresh], {
        toneType: 'none'
      });
      var reg = /[\t\r\f\n\s]*/g;
      if (typeof this.strData === 'string') {
        this.strData = this.strData.replace(reg, '');
      }
      this.form[key] = this.strData;
    },
    // 首字母转成大写
    titleCase: function titleCase(str) {
      var newStr = str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
      return newStr;
    },
    selectChange: function selectChange(e) {
      this.$emit('selectChange', e);
    },
    ueditorEdit: function ueditorEdit(val, item) {
      this.form[item.key] = val;
    },
    // 选择人员回调
    getSelectList: function getSelectList(data, item) {
      this.userList = data;
      var ids = [];
      data.map(function (item) {
        ids.push(item.value);
      });
      this.form[item.key] = ids;
    },
    goDict: function goDict() {
      window.open("".concat(roterPre, "/develop/dictionary"), '_blank');
    },
    closeFn: function closeFn() {
      this.$refs.form.resetFields();
    },
    checkboxDialogOpen: function checkboxDialogOpen() {
      if (this.form.association_field_names && this.form.association_field_names.length > 0) {
        var ids = [];
        this.fieldList.map(function (item) {
          ids.push(item.id);
        });
        var data = {
          type: this.fromData.type,
          id: this.form.association_crud_id,
          ids: ids,
          selectList: this.fieldList
        };
        this.$refs.checkboxDialog.openBox(data);
      } else {
        this.$refs.checkboxDialog.openBox();
      }
    }
  }
};